import { ContentLayout } from "../../../shared";
import * as React from "react";
import { Button, Chip, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { ServerPaginatedTable } from "../../../shared";
import { useNavigate, Link } from "react-router-dom";
import InputControl from "../../../shared/components/InputControl";
import { DeleteModal } from "../../../shared";
import { usePushNotification } from "..";

export const PushNotificationList = () => {
  const navigate = useNavigate();
  const {
    state,
    globalData,
    handleModal,
    handleDelete,
    gotoPage,
    setPageSize,
    handleSort,
    handleSearch,
    handleStatusChange,
    onSearchClear,
    resetFilters,
  } = usePushNotification({
    isList: true,
  });
  const {
    isLoading,
    dataList,
    deleteModalOpen,
    pagination,
    sortBy,
    filterApplied,
  } = state;
  const hasActiveFilters =
    Boolean(filterApplied.searchText) ||
    (filterApplied.status !== "" &&
      filterApplied.status !== null &&
      filterApplied.status !== undefined);

  const ActionButtons = ({ id, deleteAction }) => {
    return (
      <div className="action-buttons" onClick={(e) => e.preventDefault()}>
        <img alt="delete" onClick={deleteAction} src="/icons/ic_delete.svg" />
        <Link to={`/push-notification/edit/${id}`}>
          <img alt="details" src="/icons/arrow_forward.svg" />
        </Link>
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Title",
        accessor: "title",
      },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ value }) => {
          return (
            globalData?.push_notifications?.push_notification_type?.find(
              (v) => v.value == value,
            )?.label || value
          );
        },
      },
      {
        Header: "Notification text",
        accessor: "description",
      },
      {
        Header: "Scheduled Time",
        accessor: "scheduled_at",
      },
      {
        Header: "Created By",
        accessor: "name",
      },
      {
        Header: "Target Count",
        accessor: "target_count",
      },
      {
        Header: "Updated At",
        accessor: "created_at",
      },
      {
        Header: "Status",
        accessor: "status",
        disableGlobalFilter: true,
        Cell: ({ value }) => {
          const statusValue = Number(value);

          return (
            <>
              {statusValue === 2 && (
                <Chip
                  label="Completed"
                  color={"success"}
                  variant="outlined"
                  size="small"
                  sx={{
                    border: "none !important",
                  }}
                />
              )}
              {statusValue === 1 && (
                <Chip
                  sx={{
                    border: "none",
                  }}
                  label={
                    <Typography
                      color="#C07302"
                      variant="subtitle2"
                      fontWeight={400}
                    >
                      Published
                    </Typography>
                  }
                  style={{ backgroundColor: "#FFF4CE" }}
                  variant="outlined"
                  size="small"
                />
              )}
              {statusValue === 0 && (
                <Chip
                  label="Draft"
                  color="primary"
                  variant="outlined"
                  size="small"
                  sx={{ bgcolor: "#1560D414", border: "none !important" }}
                  disabled={false}
                />
              )}
              {statusValue === 3 && (
                <Chip
                  label="Cancelled"
                  color="success"
                  variant="outlined"
                  size="small"
                  disabled="filled"
                />
              )}
            </>
          );
        },
      },
      {
        Header: "Action",
        id: "action",
        accessor: "id",
        align: "right",
        disableSortBy: true,
        disableGlobalFilter: true,
        Cell: ({ value }) => {
          return (
            <ActionButtons
              id={value}
              deleteAction={() => handleModal(true, value)}
            />
          );
        },
      },
    ],
    [globalData],
  );

  return (
    <>
      <ContentLayout
        title="Push Notification"
        rightContent={
          <>
            {/* {isCreateVisible && ( */}
            <Button
              type="button"
              size="medium"
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate("create")}
            >
              New Notification
            </Button>
            {/* )} */}
          </>
        }
      >
        <ServerPaginatedTable
          columns={columns}
          data={dataList}
          key={sortBy}
          isLoading={isLoading}
          pagination={pagination}
          gotoPage={gotoPage}
          setPageSize={setPageSize}
          handleSort={handleSort}
          sortByGlobal={sortBy}
          defaultSearch={false}
          filterContent={
            <>
              <InputControl
                type="table-search"
                value={filterApplied.searchText}
                onChange={(e) => handleSearch(e.target.value)}
                onClear={onSearchClear}
              />
              <InputControl
                type="select"
                name="status"
                label="Status"
                optionValue={
                  globalData?.push_notifications?.push_notification_status ?? []
                }
                width="250px"
                onChange={handleStatusChange}
                value={filterApplied.status}
              />
              <Button
                type="button"
                size="medium"
                variant="text"
                color="gray"
                sx={{
                  minWidth: "40px",
                  p: "8px",
                }}
                onClick={resetFilters}
                disabled={!hasActiveFilters}
              >
                <CloseIcon />
              </Button>
            </>
          }
          onRowLink={(e) => {
            return `/push-notification/edit/${e.id}`;
          }}
        />
        <DeleteModal
          open={deleteModalOpen}
          handleClose={() => handleModal(false, null)}
          onConfirm={() => handleDelete()}
        />
      </ContentLayout>
    </>
  );
};
